import { Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { observer } from "mobx-react-lite";
import React, { type PropsWithChildren, type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { stripeCurrency, stripePrice } from "src/helpers/payments";
import { stripePromise } from "src/helpers/stripePromise";

interface Props {
  fallback?: ReactNode;
  fallbackClassName?: string;
  fallbackWrapperClassName?: string;
}

export const StripeElements = observer(function StripeElements(
  props: PropsWithChildren<Props>,
) {
  const { i18n } = useTranslation();
  return (
    <Elements
      stripe={stripePromise}
      options={{
        mode: "subscription",
        amount: stripePrice,
        currency: stripeCurrency,
        locale: i18n.language,
      }}
    >
      <LoadElements>{props.children}</LoadElements>
    </Elements>
  );
});

function LoadElements(props: PropsWithChildren) {
  const stripe = useStripe();
  const elements = useElements();

  if (!stripe || !elements) {
    return null;
  }

  return <>{props.children}</>;
}
